import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { CommerceService } from '../../../core/service/app/commerce.service';
import { ValidatorService } from '../../../core/service/app/validator.service';
import { DebugContext } from '@angular/core/src/view';
import { CatalogueService } from 'app/core/service/core/cataloque.service';

@Component({
  selector: 'app-offer-form',
  templateUrl: './offer-form.component.html',
  styleUrls: ['./offer-form.component.scss']
})
export class OfferFormComponent extends FormBaseComponent<any> implements OnInit {

  min = 0;
  max = 1;
  noContractList$

  total = 0;
  meses = 0;
  promedio = 0;
  randomId = ''
  permitido = false;
  montoMinimo = 150000;
  montoMaximo = 999999999999;
  cotizadorFactor = [];

  nivel = [
    { adelanto: 300000, pagopromedio: 5000, meses: 4.17 },
    { adelanto: 888888.88, pagopromedio: 5000, meses: 5.93 },
    { adelanto: 1152777.78, pagopromedio: 5000, meses: 7.69 },
    { adelanto: 1416666.67, pagopromedio: 5000, meses: 9.44 },
    { adelanto: 3000000, pagopromedio: 5000, meses: 11.20 },
  ]

  @Input() IdtmpRegister = 0;

  @Output()
  onBack = new EventEmitter<any>();

  constructor(
      private formBuilder: FormBuilder,
      private store: Store<AppState>,
      private validatorService: ValidatorService,
      private catalogeService: CatalogueService,
      private comercioService: CommerceService
      ) {
    super();
    this.randomId = (Math.random() * 789) + '';
    this.noContractList$ = this.store.select(state => state.list.no_contract);
  }

  ngOnInit() {
    this.init();
    this.validate();
    this.catalogeService.getCotizadorFactor().then(result =>{
      if(result != undefined)
      {
        this.calculosX.fComision = result.comision;
        this.calculosX.fMax = result.pMax;
        this.calculosX.fMin = result.pMin;
        this.calculosX.fPago = result.fatorPago;
        this.calculosX.fSplit = result.split;
        this.calculosX.idCotizadorParametrico = result.idCotizadorParametrico;
      }
    });
  }

  template() {
    this.form.addControl('total', new FormControl(150000));
    this.form.addControl('creditCard', new FormControl(1));

    this.form.addControl(
      'monthlySales', 
      new FormControl(
      '',
      [Validators.required, this.validatorService.montoMinimo ]
    ));


    this.form.addControl('monthlySalesCard', new FormControl(0, [Validators.required, this.validatorService.montoMinimo]));
    this.form.addControl('montoDesembolsar', new FormControl(500000, [Validators.required]));
    this.form.addControl('montoPagar', new FormControl(500000, [Validators.required]));
    this.form.addControl('split', new FormControl(500000, [Validators.required]));
    this.form.addControl('factorRepago', new FormControl(500000, [Validators.required]));
    this.form.addControl('meses', new FormControl(0, [Validators.required]));

    this.form.addControl('comision', new FormControl(0));
    this.form.addControl('comisionMonto', new FormControl(0));
    this.form.addControl('vecesVenta', new FormControl(0));
    this.form.addControl('idCotizadorParametrico', new FormControl(0));
    this.form.addControl('ratio', new FormControl(0));
    this.form.addControl('desembolsoMonto', new FormControl(0));
    this.form.addControl('devolucionMonto', new FormControl(0));
    this.form.addControl('cobranzaMonto', new FormControl(0));

  }


  //f = Facto
  //c = Captura
  //v = Valores calculados
  calculosX=
  {
    idCotizadorParametrico: 0,
    fSplit: 0,
    fPago: 0,
    fComision: 0,
    fMin: 0,
    fMax: 0,

    cMonthlySales: 0,
    cPrecioCompra: 0,
    
    vVM: 0, //ventas Mensuales
    vPVAM: 0, //porcentaje de ventas mensuales a anticipar
    vPCVP: 0, //Precio compra Valor Presente
    vCI: 0, //Comision Inicial
    vMD: 0, //Monto Desembolso
    
    vPME: 0, //Pago Mensual Esperado
    vPDE: 0, //Pago Diario Esperado
    vML: 0, //Meses a liquidar
    vDL: 0, //Dias a liquidar
    vCGC: 0, //Comision por Gestion de Cobro
    vCGCI:0, //Comision por Gestion de Cobro (IVA)
    vPTVD:0, //Porcentaje de total de ventas Diarias

    vMin: 0, //Valor Minimo
    vMax: 0, //Valor Maximo

    vR: 0 , //Ratio
    vTP: 0, //Total pagar 
  }

  saveSlider = true;

  slider = {
    min: 0,
    max: 1,
    step: 10000,
    stepCount: 20,
    exp: 100,
    meses: 0,
  };

  redondeo(valor: string, esMaximio = false):string {
    let resultado = '0';
    let ceros = '000'
    let parte = valor.substr(0, 3);
    let parte1 = parseInt(parte.substr(0, 1));
    let parte2 = parseInt(parte.substr(1, 1));
    let parte3 = parseInt(parte.substr(2, 3));

    parte2 = parte3 > 4 ? (parte2 + 1) : parte2;
    parte3 = 0;
    let valorRedondeado = Math.round(parseInt(valor)).toString();
    if (valorRedondeado.length > 6 ) {
      const aumento = valorRedondeado.length - 6;
      for (let i = 0; i < aumento; i++) {
        ceros += '0';
      }
    }

    resultado = parte1.toString() + parte2.toString() + parte3.toString() + ceros;

    return resultado;
  }

  send() {
    if(this.form.valid)
    {
      window.scrollTo(0, 0);
      const value = this.form.value.montoDesembolsar; // this.nivel[this.form.value.total].adelanto;
      this.onComplete.emit(this.form.value);
    }
  }


  back() {
    this.onBack.emit();
  }

  primera = 0;
  errorms = ''

  resetSlider() {
    this.min = 0;
    this.max = 1;
    this.slider.min = this.min;
    this.slider.max = this.max;
    this.slider.meses = 0;
    //this.form.patchValue({ total: 0 });
  }

  validate() {
    //console.log('ENTRANDO A VALIDAR', this.primera);
    this.errorms = '';

    let monto = parseFloat(this.form.value.monthlySales);
    let montoCard = parseFloat(this.form.value.monthlySalesCard);

    if(monto != 0 && montoCard != 0)
    {
      if ((monto > this.montoMaximo || montoCard > this.montoMaximo)) {
        this.errorms = 'Las ventas exceden el monto maximo'
        this.resetSlider();
      }
      if ((monto < this.montoMinimo || montoCard < this.montoMinimo)) {
        this.errorms = 'Las ventas con tarjetas bancarias deben ser superiores para acceder al anticipo. Agradecemos tu preferencia'
        this.resetSlider();
      } 
  
      if(monto < montoCard)
      {
        this.errorms = 'El monto promedio mensual de ventas no puede ser menor al monto de ventas por TDC'
        this.resetSlider();
      }

      if(this.errorms == "")
      {  
        this.calculateX();
      }
    }
  }

  saveTempOffer()
  {
    this.comercioService.SaveTmpOffer(
      {
        cobranzaMonto : (this.calculosX.vCGC + this.calculosX.vCGCI),
        comision : this.calculosX.fComision,
        comisionMonto : this.calculosX.vCI,
        desembolsoMonto : this.calculosX.vMD,
        devolucionMonto : this.calculosX.vMD + this.calculosX.vCI,
        factorRepago : this.calculosX.fPago,
        idCotizadorParametrico : this.calculosX.idCotizadorParametrico,
        idtmpRegsiter : this.IdtmpRegister,
        meses : this.calculosX.vML,
        monthlySales : parseFloat(this.form.get('monthlySales').value),
        monthlySalesCard : parseFloat(this.form.get('monthlySalesCard').value),
        montoDesembolsar : this.calculosX.vMD,
        montoPagar : this.calculosX.vTP,
        ratio : this.calculosX.vR,
        split : this.calculosX.fSplit,
        total : this.calculosX.vTP,
        vecesVenta : this.calculosX.vPVAM
      });
  }

  
  calculateX()
  {
    this.calculosX.cMonthlySales = parseFloat(this.form.get('monthlySalesCard').value);
    this.calculosX.vR = this.calculosX.cMonthlySales / parseFloat(this.form.get('monthlySales').value);

    //Establecemos valores iniciales
    this.calculosX.vMin = this.calculosX.fMin;
    this.calculosX.vMax = this.calculosX.fMax * this.calculosX.cMonthlySales;

    //Slider
    this.slider.min = this.calculosX.vMin;
    this.slider.max = this.calculosX.vMax;

    //Iniciamos Calculos
    this.calculosX.vMD = parseFloat(this.form.value.total);
    //this.calculosX.vTP = this.calculosX.vMD  / ( 1 / ( 1 + this.calculosX.fPago ) - this.calculosX.fComision ) ;
    this.calculosX.vTP = ( ( 1.16 * (this.calculosX.vMD * (this.calculosX.fPago + 1 ))) / ( (this.calculosX.fComision * (this.calculosX.fPago + 1.16 ) ) - 1.16) ) * -1;
    this.calculosX.vPCVP = this.calculosX.vTP / ( 1 + this.calculosX.fPago );

    this.calculosX.vCI = ( this.calculosX.vPCVP + ( ( this.calculosX.vTP - this.calculosX.vPCVP ) / 1.16 ) ) * this.calculosX.fComision;

    this.calculosX.cPrecioCompra = this.calculosX.vTP;
   
    this.calculosX.vVM = this.calculosX.cMonthlySales;
    this.calculosX.vPVAM = this.calculosX.vVM != 0 ? this.calculosX.cPrecioCompra / this.calculosX.vVM : 0;
    this.calculosX.vPME = this.calculosX.cMonthlySales * this.calculosX.fSplit;
    this.calculosX.vPDE = this.calculosX.vPME / 30;

    this.calculosX.vML = this.calculosX.vTP / this.calculosX.vPME;
    this.calculosX.vDL = this.calculosX.vTP / this.calculosX.vPDE;

    this.calculosX.vML = Math.round(this.calculosX.vML);

    this.calculosX.vCGC = (this.calculosX.cPrecioCompra - this.calculosX.vPCVP) / 1.16;
    this.calculosX.vCGCI = this.calculosX.vCGC * .16;

    this.calculosX.vPTVD = ((this.calculosX.vCGC / this.calculosX.vTP) * this.calculosX.fSplit) * 100 ;


    this.form.patchValue({
      'montoDesembolsar': this.calculosX.vMD,
      'montoPagar': this.calculosX.vTP,
      'split': this.calculosX.fSplit ,
      'factorRepago': this.calculosX.fPago,
      'meses': this.calculosX.vML,
      'comision': this.calculosX.fComision,
      'comisionMonto': this.calculosX.vCI,
      'vecesVenta': this.calculosX.vPVAM,
      'idCotizadorParametrico': this.calculosX.idCotizadorParametrico,
      'ratio': this.calculosX.vR,
      'desembolsoMonto': this.calculosX.vMD,
      'devolucionMonto': this.calculosX.vMD + this.calculosX.vCI,
      'cobranzaMonto': (this.calculosX.vCGC + this.calculosX.vCGCI),
    });

    this.saveTempOffer();

  }
}







 


// WEBPACK FOOTER //
// ./src/app/form/form/offer-form/offer-form.component.ts